function rkSort<T>(this: Array<T>, comparator: (a: T, b: T) => number) {
  const arrayCopy = [...this.values()];

  return arrayCopy.sort(comparator);
}

export default rkSort;
